<template>
  <div>
    <el-form ref="form" :model="multimediaForm" label-width="100px">
      <el-form-item label="课程名：">
        <el-input disabled v-model="multimediaForm.courseName"></el-input>
      </el-form-item>
      <el-form-item label="姓名：">
        <el-input disabled v-model="multimediaForm.memberName"></el-input>
      </el-form-item>
      <el-form-item
        label="图片"
        v-if="defaultConfig.imageConfig && defaultConfig.imageConfig.enable"
      >
        <p style="color: red">
          最多上传{{ defaultConfig.imageConfig.maxNumber }}张图片
        </p>
        <!-- <multi-upload :limit="defaultConfig.imageConfig.maxNumber" v-model="multimediaForm.image"></multi-upload> -->
        <uploadImage
          v-model="multimediaForm.image"
          :limit="defaultConfig.imageConfig.maxNumber"
        ></uploadImage>
      </el-form-item>
      <el-form-item
        label="视频文件："
        v-if="defaultConfig.imageConfig && defaultConfig.videoConfig.enable"
      >
        <p style="color: red">
          最多上传{{ defaultConfig.videoConfig.maxNumber }}个视频
        </p>
        <upload-video
          v-model="multimediaForm.video"
          :limitNum="defaultConfig.videoConfig.maxNumber"
          ref="uploadRefs"
          :limitSize="limitSize"
        ></upload-video>
        <!-- v-model="multimediaForm.video" -->
      </el-form-item>
      <el-form-item label="备注：">
        <el-input
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 6 }"
          maxlength="300"
          show-word-limit
          v-model="multimediaForm.remark"
        ></el-input>
      </el-form-item>
      <el-form-item label="录音:" v-if="defaultConfig.audioEnable">
        <div style="display: flex;align-items: center;">
          <soundRecording
          ref="soundRecord"
          @clickRecStop="clickRecStop"
          @clickRecClear="clickRecClear"
        />
        <div v-if="multimediaForm.audio" style="margin-left: 20px;">
          <audio controls ref="audio" class="aud">
            <source :src="multimediaForm.audio" />
          </audio>
        </div>
        </div>

      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import uploadVideo from "./upload-video.vue";
import soundRecording from "@/components/soundRecording";
import MultiUpload from "@/components/Upload/multiUpload";
import { getCourseMediaData } from "@/api/AfterClassService";
import uploadImage from "./upload-image.vue";

export default {
  props: {
    courseRocordId: {
      type: [Number, String],
      default: null,
    },
    defaultConfig: {
      type: Object,
      default: () => {},
    },
    currentRow: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    uploadVideo,
    soundRecording,
    MultiUpload,
    uploadImage,
  },
  data() {
    return {
      multimediaForm: {
        image: [],
        video: [],
        audio: "",
      },
      selectProductPics: [],
      limitNum: 2,
      limitSize: 500,
    };
  },
  mounted() {
    this.resetForm();
  },
  methods: {
    resetForm() {
      console.log("充值视频数据");
      this.multimediaForm = {
        image: [],
        video: [],
        audio:'',
        remark:undefined
      };
    },
    getFetch() {
      getCourseMediaData({ id: this.courseRocordId }).then((response) => {
        console.log(response,'response=========')
        this.multimediaForm = {
          ...response.data,
          image:
            response.data.image && response.data.image.length
              ? response.data.image
              : [],
          video:
            response.data.video && response.data.video.length
              ? response.data.video
              : [],
          ...this.currentRow,
          audio:response.data.audio ? response.data.audio : '',
          remark:response.data.remark ? response.data.remark : ''
        };
        // if (response.data.audio) {
        //   this.$refs.soundRecord.recBlob = true;
        // }
        // this.$nextTick(() => {
        //   this.$refs.soundRecord.audio = response.data.audio;
        //   this.$refs.soundRecord.localUrl = response.data.audio;
        //   // = response.data.audio
        // });

        // console.log(this.$refs.soundRecord, "this.multimediaForm====");
      });
    },
    clickRecStop(audio) {
      if (audio == 1) {
        this.$refs.soundRecord.recStop();
        let timer = setInterval(() => {
          this.multimediaForm.audio = this.$refs.soundRecord.audio;
          this.$refs.audio.src = this.multimediaForm.audio 
          this.$refs.soundRecord.dialogVisible = false;
          // console.log(this.$refs.soundRecord.audio, 'refs.soundRecord.audio')
          clearInterval(timer);
        }, 500);
      } else {
        let timer = setInterval(() => {
          this.multimediaForm.audio = this.$refs.soundRecord.audio;
          this.$refs.audio.src = this.multimediaForm.audio 
          this.$refs.soundRecord.dialogVisible = false;
          // console.log(this.$refs.soundRecord.audio, 'refs.soundRecord.audio')
          clearInterval(timer);
        }, 500);
      }
    },
    clickRecClear() {
      this.multimediaForm.audio = "";
    },
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/views/service/components/multimedia.vue